import { IconButton, Typography, Box, useTheme } from "@mui/material";
import React from "react";
import { Chat } from "@mui/icons-material";
import useResponsive from "../../hooks/useResponsive";
export type IRemarksCardProps = {
  handleOpenDialog: () => void;
  handleOpenDailyRemarkDialog: () => void;
  pmRemarkStatus: boolean | null | undefined;
  pmDailyRemarkStatus: boolean | null | undefined;
};

const RemarksCard: React.FC<IRemarksCardProps> = ({
  handleOpenDialog,
  handleOpenDailyRemarkDialog,
  pmRemarkStatus,
  pmDailyRemarkStatus,
}) => {
  const theme = useTheme();
  const { isDesktop, isMobile } = useResponsive();
  return (
    <Box
      sx={{
        display: "flex",
        width: "90%",
        flexDirection: "row",
        mt: !isDesktop ? "35px" : "25px",
      }}
    >
      {/* PM Remarks section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flex: 1,
        }}
      >
        <Typography
          fontFamily={"Nunito Sans SemiBold"}
          sx={{
            color: theme.palette.primary.main,
            mr: 1,
            fontSize: "15px",
            whiteSpace: "nowrap",
          }}
        >
          {isMobile ? "PM" : "Opmerking PM"}
        </Typography>
        <IconButton onClick={() => handleOpenDialog()}>
          <Chat
            fontSize="medium"
            sx={{
              color: pmRemarkStatus ? "red" : theme.palette.primary.main,
            }}
          />
        </IconButton>
      </Box>

      {/* Daily Remarks section */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "end",
          flex: 1,
        }}
      >
        <Typography
          fontFamily={"Nunito Sans SemiBold"}
          sx={{
            color: theme.palette.primary.main,
            mr: 1,
            fontSize: "15px",
            whiteSpace: "nowrap",
          }}
        >
          {isMobile ? "Dag" : "Opmerking dag"}
        </Typography>
        <IconButton onClick={() => handleOpenDailyRemarkDialog()}>
          <Chat
            fontSize="medium"
            sx={{
              color: pmDailyRemarkStatus ? "red" : theme.palette.primary.main,
            }}
          />
        </IconButton>
      </Box>

    </Box>
  );
};

export { RemarksCard };
